import { createContext } from 'react';
import { IComboGroupPositionItem, IUpdateComboGroupPositions } from 'types';

export type TChangeComboGroupPositionSelectedItem = Nullable<string>;
export type TTypeOfChangeComboGroupPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface IChangeComboGroupPositionState {
	IDSelectedCustomer: TChangeComboGroupPositionSelectedItem;
	IDSelectedRestaurant: TChangeComboGroupPositionSelectedItem;
	IDSelectedDish: TChangeComboGroupPositionSelectedItem;
	positionsData: IComboGroupPositionItem[];
	dataForSubmit: IUpdateComboGroupPositions | null;
	typeOfModalWindow: TTypeOfChangeComboGroupPositionModalWindow;
}

export const changeComboGroupPositionInitialState: IChangeComboGroupPositionState = {
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedDish: null,
	positionsData: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IChangeComboGroupPositionContext extends IChangeComboGroupPositionState {
	setIDCustomer(value: TChangeComboGroupPositionSelectedItem): void;
	setIDRestaurant(value: TChangeComboGroupPositionSelectedItem): void;
	setIDDish(value: TChangeComboGroupPositionSelectedItem): void;
	resetSelectedControls(): void;
	setPositionsData(data: IComboGroupPositionItem[]): void;
	reorderItems(value: IComboGroupPositionItem[]): void;
	setDataForSubmit(value: IUpdateComboGroupPositions | null): void;
	changeTypeOfModalWindow(value: TTypeOfChangeComboGroupPositionModalWindow): void;
}

export const ChangeComboGroupPositionContext = createContext<IChangeComboGroupPositionContext>({
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDDish: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...changeComboGroupPositionInitialState,
});
